import type { AllRouteEndpoints } from "../routeTypes";

export const alloysPartnersShopifyAppGroupIdBridgesBridgeId =
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id";

export const alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys: AllRouteEndpoints[] = [
  "/alloys/partners/shopify/:app_group_id/bridges",
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id",
  "/alloys/partners/shopify/:integration_id/fetch_segments",
];
